import ChartEchats from './Echarts';
import { Justify } from 'tea-component';
import {DefaultChatsValue} from './DefaultChatsValue';
import React from 'react';
import NoData from '@/pages/intelligence/components/NoData';
import { useIntl } from 'umi';
/**
 * data 结构
 * {
 *   seriesData:[{
  *    name: 'xxx',
  *    data: [1,2,3,4,5],
  *    color: '#000000',
  *    type: 'line'
  *  }],
 *  xAxisData: [],
 *  type: 'line',
 * }
 * 
 * **/
const Chart = (props: any)=> {
  const { leftTitle='', rightTitle='', type='line', data, onHasDataChange, ...rest } = props;
  const { formatMessage } = useIntl();
  
  // 检查是否有有效数据
  const hasData = data && 
    data.seriesData && 
    Array.isArray(data.seriesData) && 
    data.seriesData.length > 0 &&
    data.seriesData.some((series: any) => {
      if (!series || !series.data || !Array.isArray(series.data)) return false;
      // 检查是否有非 null 的有效值
      return series.data.some((item: any) => {
        if (item === null || item === undefined) return false;
        // 如果是对象格式 {value: xxx}，检查 value 字段
        if (typeof item === 'object' && 'value' in item) {
          // 检查 value 不是 null、undefined 或空字符串
          return item.value !== null && item.value !== undefined && item.value !== '';
        }
        // 如果是数字或其他有效值（但排除空字符串）
        if (item === '') return false;
        return true;
      });
    });
  
  // 通知父组件 hasData 状态变化
  React.useEffect(() => {
    if (onHasDataChange) {
      onHasDataChange(hasData);
    }
  }, [hasData, onHasDataChange]);
  
  const options = DefaultChatsValue(data);
  const typeTemplate: any = {
    line: <ChartEchats options={options} {...rest}></ChartEchats>,
    bar: <ChartEchats options={options} {...rest}></ChartEchats>
  };
  // 渲染类型
  
  return <>
    <Justify
      className="dbo-bar-line-title-info"
      left={leftTitle}
      right={rightTitle}
    ></Justify>
    {hasData ? typeTemplate?.[type] : (
      <div style={{ minHeight: rest.height || '320px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <NoData text={formatMessage({ id: 'dbs_empty_text' })} />
      </div>
    )}
  </>;
};
export default Chart;